// extracted by mini-css-extract-plugin
export var base = "MovePageConfirm-module--base--3NjjY";
export var base__title = "MovePageConfirm-module--base__title--QIIx3";
export var base__description = "MovePageConfirm-module--base__description--3JaAb";
export var base__enter = "MovePageConfirm-module--base__enter--3JQAa";
export var base__cancel = "MovePageConfirm-module--base__cancel--b6g9N";
export var hitarea = "MovePageConfirm-module--hitarea--2UMH2";
export var linkLineloop = "MovePageConfirm-module--link-lineloop--6Sx4_";
export var keyGnav = "MovePageConfirm-module--key-gnav--3ZNUa";